<!-- Виджет быстрых переходов к избранным калькуляторам. -->
<template>
  <HomeSection v-if="items.length" title="Калькуляторы">
    <template #actions>
      <button
        class="calculator-presets-widget__settings"
        title="Настройки калькуляторов"
        type="button"
        @click="$router.push({ name: 'CalculatorPresets' })"
      >
        <AppIcon name="settings" :size="14" />
      </button>
    </template>

    <HomeQuickActionCard
      v-for="item in items"
      :key="item.key"
      :label="item.label"
      icon-name="homeCalculator"
      color="indigo"
      :icon-background="iconColor(item.code)"
      @click="$router.push({
        name: 'OperationalCalculator',
        query: { preset: item.code },
      })"
    />
  </HomeSection>
</template>

<script>
import { mapState } from "pinia";
import AppIcon from "@/components/Icon/AppIcon.vue";
import HomeQuickActionCard from "@/components/Home/QuickActionCard.vue";
import HomeSection from "@/components/Home/Section.vue";
import { useCalculatorPresetsStore } from "@/stores/calculatorPresetsStore";

const PRESET_COLORS = [
  "linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)",
  "linear-gradient(135deg, #3b82f6 0%, #6366f1 100%)",
  "linear-gradient(135deg, #0891b2 0%, #06b6d4 100%)",
  "linear-gradient(135deg, #16a34a 0%, #84cc16 100%)",
  "linear-gradient(135deg, #0ea5e9 0%, #10b981 100%)",
  "linear-gradient(135deg, #f59e0b 0%, #f97316 100%)",
  "linear-gradient(135deg, #16a34a 0%, #15803d 100%)",

  "linear-gradient(135deg, #7c3aed 0%, #4f46e5 100%)",
];

export default {
  name: "CalculatorPresetsWidget",

  components: {
    AppIcon,
    HomeQuickActionCard,
    HomeSection,
  },

  computed: {
    ...mapState(useCalculatorPresetsStore, ["presets"]),

    items() {
      const enabled = this.presets.filter((p) => p.enabled);
      const sorted = [...enabled].sort((a, b) => {
        if (a.primary && !b.primary) return -1;
        if (!a.primary && b.primary) return 1;
        return 0;
      });

      return sorted.slice(0, 5).map((p) => ({
        key: p.id,
        code: p.code,
        label: p.name,
      }));
    },
  },

  methods: {
    iconColor(code) {
      let hash = 0;
      for (let i = 0; i < code.length; i++) {
        hash = code.charCodeAt(i) + ((hash << 5) - hash);
      }

      return PRESET_COLORS[Math.abs(hash) % PRESET_COLORS.length];
    },
  },

  async mounted() {
    const store = useCalculatorPresetsStore();
    await store.fetchPresets();
  },
};
</script>

<style scoped>
.calculator-presets-widget__settings {
  display: flex;
  align-items: center;
  padding: 2px;
  border: none;
  background: none;
  color: #bbb;
  cursor: pointer;
  transition: color 0.15s;
}

.calculator-presets-widget__settings:hover {
  color: #666;
}
</style>
